import * as $ from 'jquery'
import { Site } from './Site'

class Main {
  private site: Site

  constructor() {
    $(this.init.bind(this))
    // console.log('Main() - Wait for dom loaded')
  }  

  private init() {
    // console.log('   Dom loaded. Init site.')
    this.site = new Site()
  }
}

new Main()
